import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import PageLoading from "../../../components/Loading/PageLoading";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import BASEURL from "../../../pages/Utils/Baseurl";
import request from "graphql-request";
import { allUsers } from "./employeeData";
import URL from "../../../pages/Utils/url";
import Swal from "sweetalert2";
import RoleAccess from "../../function/RoleAccess";
const EmployeeTabel = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchdata();
  }, []);

  const fetchdata = () => {
    setIsLoading(true);
    request(BASEURL, allUsers)
      .then((res) => {
        const newdata = res?.allUsers?.map((val) => ({
          ...val,
          profilePicture: val.profilePicture
            ? `${URL}media/${val?.profilePicture}`
            : null,
        }));
        setData(newdata);
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const EmployeeListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Employee Name",
        field: "employeeName",
        name: "employeeName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Employee Code",
        field: "employeeCode",
        name: "employeeCode",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Role",
        field: "role",
        name: "role",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Profile Picture",
        field: "profilePicture",
        name: "profilePicture",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
     
      {
        headerName: "Create Date",
        field: "createdAt",
        name: "createdAt",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      employeeName: _.capitalize(v?.employeeName),
      employeeCode: v?.employeeCode,
      email: v?.email,
      contactNumber: v?.contactNumber,
      role: v?.role?.role,
      profilePicture: v?.profilePicture ? (
        <img src={v?.profilePicture} alt="logo" width={50} height={30} />
      ) : (
        <span>No image</span>
      ),
      createdBy:v?.createdBy,
      createdAt: v?.createdAt?.slice(0, 10),

      Action:
      
      (
        <div
          style={{
            display: "flex",

            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess modelName="Employee Screen" component="ViewEmployee">
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/employee/view-employee`, {
                  state: { type: "view", data: v },
                })
              }
            />
          </RoleAccess>
          {/* <RoleAccess modelName="Employee Screen" component="UpdateEmployee"> */}
            <EditIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/employee/edit-employee`, {
                  state: { type: "edit", data: v },
                })
              }
            />
          {/* </RoleAccess> */}
          {/* 
            <DeleteIcon

               fontSize='small'
               className="actionIcon"
              onClick={() => handleDelte(v?.id)}
            /> */}
        </div>
      ),
    })),
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Employee List
                </MaterialTypography>
              </Stack>
              {/* <RoleAccess
                modelName="Employee Screen"
                component="CreateEmployee"
              > */}
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/employee/add-employee", {
                      state: { type: "add" },
                    })
                  }
                >
                  Employee
                </MaterialButton>
              {/* </RoleAccess> */}
            </Stack>
          }
        />

        {!isLoading && (
          <MaterialDataGrid
            // customHeight={550}
            rows={EmployeeListTable?.rows}
            columns={EmployeeListTable?.columns}
            // checkboxSelection={false}
            isSelectable={false}
            // onRowClick={onCustomerListClick}
            //   loading={pageState.loading}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Employee found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet add any employee details. Click on the "Add
                    Employee" button to start adding employee details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default EmployeeTabel;
